<template>
  <a-card :bordered="false">
    <a-form-model
      ref="form"
      :label-col="formItemLayout.labelCol"
      :wrapper-col="formItemLayout.wrapperCol"
      :model="baseDataForm"
      :rules="baseDataRules"
    >
      <a-form-model-item label="预约说明" prop="bespeakExplain">
        <a-textarea v-model="baseDataForm.bespeakExplain" style="max-width: 400px;" placeholder="请输入"
                    :maxLength="140" :rows="4"/>
      </a-form-model-item>
      <a-form-model-item label="日历模式" :required="true" prop="bespeakPriceMode">
        <a-radio-group :disabled="disabledDate" v-model="baseDataForm.bespeakPriceMode">
          <a-radio :value="1">标准日历</a-radio>
          <a-radio :value="2">酒店日历</a-radio>
        </a-radio-group>
      </a-form-model-item>
      <a-form-model-item v-if="couponType=='JHM'" label="联系人信息" :required="true" prop="activateContractInfo">
        <a-radio-group v-model="baseDataForm.activateContractInfo">
          <a-radio :value="1">仅能使用激活人信息</a-radio>
          <a-radio :value="2">可使用其他人信息</a-radio>
        </a-radio-group>
      </a-form-model-item>
      <div v-show="baseDataForm.activateContractInfo==2">
        <a-form-model-item label="联系人信息">
          <LinkmanItem ref="linkMan" :contractMessage="baseDataForm.contractInfo"
                       :requiredList="baseDataForm.mustContractInfo"
                       @change="changeLinkMan"
          ></LinkmanItem>
        </a-form-model-item>
      </div>
      <a-form-model-item label="游客信息" required>
        <a-select v-model="baseDataForm.isPlayerInfo" @change="onPlayerChange" style="max-width: 400px"
                  placeholder="请选择">
          <a-select-option :value="0">不需要游客信息</a-select-option>
          <a-select-option :value="1">仅需一人信息</a-select-option>
          <a-select-option :value="2">需要所有游客信息</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item v-if="baseDataForm.isPlayerInfo>0" label="  " :colon="false">
        <a-checkbox-group v-model="baseDataForm.touristinformation" placeholder="请选择">
          <a-checkbox
            v-for="item in touristInfoList"
            :key="item.code"
            :value="item.code">{{ item.name }}
          </a-checkbox>
        </a-checkbox-group>
      </a-form-model-item>
      <a-form-model-item label="  " :colon="false" :style="{'margin-top': baseDataForm.isPlayerInfo===1?'24px':''}">
        <a-button type="primary" @click="saveEvent" style="width: 100px" :loading="saveLoading">保存设置</a-button>
      </a-form-model-item>
    </a-form-model>
  </a-card>
</template>

<script>
import formMixin from '@/utils/mixins/formMixins'
import LinkmanItem from '@/views/product/productGroup/components/LinkmanItem'

export default {
  name: 'SettingComponents',
  components: { LinkmanItem },
  mixins: [formMixin],
  props: {
    initState: {
      type: Function,
      default: undefined,
      required: true
    },
    activateKey: {
      type: String,
      default: 'tab1'
    }
  },
  data() {
    return {
      baseDataForm: {
        contractInfo: '',
        mustContractInfo: '',
        touristinformation: [],
        isPlayerInfo: 0,
        bespeakExplain: '',
        bespeakPriceMode: 1,//日历模式 1标准日历 2酒店日历
        activateContractInfo: 2
      },
      baseDataRules: {
        bespeakExplain: [
          { required: true, message: '请输入预约说明', trigger: 'change,blur' }
        ],
        bespeakPriceMode: [
          { required: true, message: '请选择日历模式', trigger: 'blur' }
        ]
      },
      selectedContactId: undefined,
      selectedRequired: false,
      disabledDate: false,
      touristInfoList: [],
      proId: '',
      couponType: ''
    }
  },

  created() {
    this.touristInfoList = this.getAppConstants().getTouristInfoList()
  },
  mounted() {
    this.proId = this.getPageParams().proId
    this.couponType = this.getPageParams().couponType
    this.getPackageDetails()
  },
  methods: {
    changeLinkMan(data) {
      this.getLogUtils().logWithTag('changeLinkMan', data)
      this.baseDataForm.contractInfo = data.str
      this.baseDataForm.mustContractInfo = data.requiredStr
    },
    onPlayerChange(value) {
      this.baseDataForm.touristinformation = []
    },
    checkForm() {
      if (this.baseDataForm.isPlayerInfo != 0) {
        const list = this.baseDataForm.touristinformation
        if (list && list.length < 1) {
          this.$message.error('请选择游客证件类型')
          return false
        }
      }
      return true
    },
    saveEvent() {
      this.$refs['form'].validate(valid => {
        this.getLogUtils().logWithTag('===form====', valid)
        if (valid) {
          if (this.checkForm()) {
            this.updateRequest()
          }

        }
      })
    },
    getPackageDetails() {
      this.getHttpServices().getCouponService().post('reserve/getReserveOrderInfo/' + this.proId)
        .then(detail => {
          this.disabledDate = detail.bespeakPriceMode > 0//大于0，不能再次设置日期
          this.initState(detail.bespeakPriceMode > 0)
          this.baseDataForm.bespeakExplain = detail.bespeakExplain
          this.baseDataForm.contractInfo = detail.contractInfo ? detail.contractInfo : ''
          this.baseDataForm.mustContractInfo = detail.mustContractInfo ? detail.mustContractInfo : ''
          this.baseDataForm.isPlayerInfo = detail.isPlayerInfo
          this.baseDataForm.touristinformation = detail.touristinformation ? detail.touristinformation.split(',') : []
          this.$nextTick(() => {
            if (this.couponType == 'JHM') {
              this.baseDataForm.bespeakPriceMode = detail.bespeakPriceMode ? detail.bespeakPriceMode : 2
              if (detail.contractInfo) {
                this.baseDataForm.activateContractInfo = 2
              } else {
                this.baseDataForm.activateContractInfo = 1
              }
            } else {
              this.baseDataForm.activateContractInfo = 2
              this.baseDataForm.bespeakPriceMode = detail.bespeakPriceMode ? detail.bespeakPriceMode : 1
            }
            this.updateContacts()
          })
          this.getLogUtils().logWithTag('this.baseDataForm', this.baseDataForm)
        }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    updateContacts() {
      this.$refs.linkMan.getLinkInfo(this.baseDataForm.contractInfo, this.baseDataForm.mustContractInfo)
    },
    updateRequest() {
      this.saveLoading = true
      const activateContractInfo = this.baseDataForm.activateContractInfo
      let newContractInfo = ''
      let newMustContractInfo = ''
      if (activateContractInfo == 2) {
        let arr = this.baseDataForm.contractInfo.split(',')
        this.getLogUtils().logWithTag('contractInfo', arr)
        newContractInfo = this.baseDataForm.contractInfo
        if (this.baseDataForm.mustContractInfo) {
          let list = ['1', '2', ...this.baseDataForm.mustContractInfo.split(',')]
          newMustContractInfo = [...new Set(list)].join(',')
        } else {
          newMustContractInfo = '1,2'
        }
      }
      const params = {
        proId: this.proId,
        activateContractInfo: activateContractInfo,
        bespeakExplain: this.baseDataForm.bespeakExplain,
        bespeakPriceMode: this.baseDataForm.bespeakPriceMode,
        isPlayerInfo: this.baseDataForm.isPlayerInfo,
        touristinformation: this.baseDataForm.touristinformation ? this.baseDataForm.touristinformation.join(',') : '',
        contractInfo: newContractInfo,//所有的联系人
        mustContractInfo: newMustContractInfo
      }
      this.getLogUtils().logWithTag('params', params)
      this.getHttpServices().getCouponService().post('reserve/saveOrUpdateReserveOrderInfo', params)
        .then(res => {
          this.$emit('success', { ...res })
        }).catch(reason => this.showNetWorkErrorMessage(reason))
        .finally(() => this.saveLoading = false)
    }
  }

}
</script>
<style scoped>
</style>